import { initAnimStack } from "./animStack";

// Polylang Dropdown
document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".lang-dropdown__option-item");

  // FIX: Only exit if NO options are found on the page
  if (!options.length) {
    return;
  }

  options.forEach(function (option) {
    option.addEventListener("click", function () {
      window.location.href = this.getAttribute("data-url");
    });
  });
});

// drawer
document.addEventListener("DOMContentLoaded", function () {
  // 1. Target the elements based on your HTML
  const btnOpen = document.querySelector(".menu--button-open");
  const btnClose = document.querySelector(".menu--button-close");
  const drawer = document.querySelector("#mobile-menu-drawer");

  // Exit if the drawer doesn't exist on this page
  if (!drawer) return;

  const drawerMenuLinkEls = drawer.querySelectorAll("a");

  // 2. Main toggle function
  function setDrawer(open) {
    if (open) {
      // Calculate scrollbar width to prevent layout shift
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      drawer.classList.add("open");
      document.body.style.paddingRight = `${scrollbarWidth}px`; // Add padding
      document.querySelector("#mobile-menu-drawer").style.paddingRight =
        `${scrollbarWidth}px`; // Add padding
      document.body.style.overflow = "hidden"; // Lock background scroll
    } else {
      drawer.classList.remove("open");
      document.body.style.paddingRight = `0`;
      document.querySelector("#mobile-menu-drawer").style.paddingRight = ""; // Remove padding
      document.body.style.overflow = ""; // Unlock background scroll
    }

    // Accessibility attributes
    if (btnOpen) btnOpen.setAttribute("aria-expanded", open ? "true" : "false");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
  }

  // 3. Event Listeners for Open and Close buttons
  if (btnOpen) {
    btnOpen.addEventListener("click", () => setDrawer(true));
  }

  if (btnClose) {
    btnClose.addEventListener("click", () => setDrawer(false));
  }

  // 4. Close the drawer when any link inside it is clicked
  drawerMenuLinkEls.forEach((link) => {
    link.addEventListener("click", () => setDrawer(false));
  });

  // 5. Close the drawer when pressing the Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("open")) {
      setDrawer(false);
    }
  });
});

// mega menu
document.addEventListener("DOMContentLoaded", function () {
  var headerEl =
    document.querySelector("#_header-94-1140") ||
    document.querySelector(".oxy-header");
  var megaItems = document.querySelectorAll(
    "#header-menu > li.mega-row, #header-menu > li.mega-col",
  );
  if (!headerEl || !megaItems.length) return;

  var headerHeight = headerEl.offsetHeight;

  var panel = document.createElement("div");
  panel.className = "mega-panel";
  panel.style.top = headerHeight + "px";
  var inner = document.createElement("ul");
  inner.className = "mega-panel-inner";
  panel.appendChild(inner);
  document.body.appendChild(panel);

  var cache = [];
  megaItems.forEach(function (item) {
    var sub = item.querySelector(":scope > .sub-menu");
    if (!sub) return;
    var mode = item.classList.contains("mega-row") ? "mode-row" : "mode-col";
    cache.push({ item: item, html: sub.innerHTML, mode: mode });
  });

  var closeTimer = null;
  var currentItem = null;

  function open(entry) {
    clearTimeout(closeTimer);
    closeTimer = null;

    if (currentItem !== entry.item) {
      // 1. Reset ARIA for the previously open item if we are switching directly
      if (currentItem) {
        var prevLink = currentItem.querySelector("a");
        if (prevLink) prevLink.setAttribute("aria-expanded", "false");
      }

      inner.innerHTML = entry.html;
      panel.classList.remove("mode-row", "mode-col");
      panel.classList.add(entry.mode);
      currentItem = entry.item;
    }

    // 2. Set ARIA to true for the currently hovered item
    var currentLink = entry.item.querySelector("a");
    if (currentLink) currentLink.setAttribute("aria-expanded", "true");

    panel.style.transition = "none";
    panel.style.height = "auto";
    var h = panel.offsetHeight;
    panel.style.height = "0px";
    panel.offsetHeight;
    panel.style.transition = "height 0.35s ease, opacity 0.35s ease";

    panel.style.height = h + "px";
    panel.style.opacity = "1";
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      panel.style.height = "0px";
      panel.style.opacity = "0";

      // 3. Reset ARIA to false when the panel completely closes
      if (currentItem) {
        var activeLink = currentItem.querySelector("a");
        if (activeLink) activeLink.setAttribute("aria-expanded", "false");
      }

      currentItem = null;
    }, 200);
  }

  cache.forEach(function (entry) {
    entry.item.addEventListener("mouseenter", function () {
      open(entry);
    });
    entry.item.addEventListener("mouseleave", scheduleClose);
  });

  panel.addEventListener("mouseenter", function () {
    clearTimeout(closeTimer);
    closeTimer = null;
  });
  panel.addEventListener("mouseleave", scheduleClose);
});
initAnimStack();
